export default (state, payload) => {
  state.sidebar_option = payload;
};
